<template>
    <header class="header-global mt-2">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <div class="col-lg-4">
                <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                    <img src="/img/brand/logo_b.svg" alt="logo">
                </router-link>
            </div>
            <div class="col-lg-8">
                <div class="row pt-3">
                    <div class="ml-auto mr-0 text-right">{{$root.phone}}<br>{{$root.email}}</div>
                    <ul class="navbar-nav social ml-auto mr-0 d-none">
                        <li class="nav-item">
                            <a class="nav-link nav-link-icon rounded-circle" href="/" target="_blank" rel="noopener"
                               data-toggle="tooltip" title="Like us on Facebook">
                                <i class="fa fa-facebook"></i>
                                <span class="nav-link-inner--text d-lg-none">Facebook</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link nav-link-icon rounded-circle" href="/"
                               target="_blank" rel="noopener" data-toggle="tooltip" title="Follow us on Instagram">
                                <i class="fa fa-instagram"></i>
                                <span class="nav-link-inner--text d-lg-none">Instagram</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link nav-link-icon rounded-circle" href="/" target="_blank" rel="noopener"
                               data-toggle="tooltip" title="Follow us on Twitter">
                                <i class="fa fa-twitter"></i>
                                <span class="nav-link-inner--text d-lg-none">Twitter</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link nav-link-icon rounded-circle" href="/"
                               target="_blank" rel="noopener" data-toggle="tooltip" title="Like us on VK">
                                <i class="fa fa-vk"></i>
                                <span class="nav-link-inner--text d-lg-none">VK </span>
                            </a>
                        </li>
                        <li class="nav-item mr-0">
                            <a class="nav-link nav-link-icon rounded-circle" href="/"
                               target="_blank" rel="noopener" data-toggle="tooltip" title="Watch us on Youtube">
                                <i class="fa fa-youtube-play"></i>
                                <span class="nav-link-inner--text d-lg-none">Youtube </span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="row pt-3">
                    
                </div>
            </div>
            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu" id="closeMenu"></close-button>
                </div>
            </div>
            <div>
                <ul class="navbar-nav navbar-nav-hover align-items-lg-center pl-3">
                    <base-dropdown tag="li" class="nav-item">
                        <router-link slot="title" to="/products" class="nav-link" data-toggle="dropdown" role="button">
                            <i class="ni ni-collection d-lg-none"></i>
                            <span class="nav-link-inner--text">Продукты</span>
                        </router-link>
                        <router-link to="/product/cadflo" @click.native="closeMenuMobile" class="dropdown-item">CADFLO</router-link>
                        <router-link to="/product/IMAD" @click.native="closeMenuMobile" class="dropdown-item">IMAD</router-link>
                    </base-dropdown>
                    <base-dropdown class="nav-item">
                        <router-link slot="title" to="/solutions" class="nav-link" data-toggle="dropdown" role="button">
                            <i class="ni ni-ui-04 d-lg-none"></i>
                            <span class="nav-link-inner--text">Решения</span>
                        </router-link>
                        <router-link to="/solution/prochnost" @click.native="closeMenuMobile" class="dropdown-item">Прочность</router-link>
                        <router-link to="/solution/gidrogazodinamika" @click.native="closeMenuMobile" class="dropdown-item">Гидрогазодинамика (CFD)</router-link>
                        <router-link to="/solution/elektromagnetizm" @click.native="closeMenuMobile" class="dropdown-item">Электромагнитный анализ</router-link>
                        <router-link to="/solution/teplovoy-analiz" @click.native="closeMenuMobile" class="dropdown-item">Тепловой анализ</router-link>
                    </base-dropdown>
                    <li tag="li" class="nav-item usually">
                        <router-link slot="title" to="/prices" class="nav-link" role="button" @click.native="closeMenuMobile">
                            <i class="ni ni-collection d-lg-none"></i>
                            <span class="nav-link-inner--text">Стоимость</span>
                        </router-link>
                    </li>
					<li tag="li" class="nav-item usually">
                        <router-link slot="title" to="/about" class="nav-link" role="button" @click.native="closeMenuMobile">
                            <i class="ni ni-collection d-lg-none"></i>
                            <span class="nav-link-inner--text">О компании</span>
                        </router-link>
                    </li>
                    <li tag="li" class="nav-item usually">
                        <a slot="title" href="http://my.cadflo.com/" class="nav-link" role="button" target="_blank">
                            <i class="ni ni-collection d-lg-none"></i>
                            <span class="nav-link-inner--text">Техподдержка</span>
                        </a>
                    </li>
					<li tag="li" class="nav-item usually">
                        <router-link slot="title" to="/news" class="nav-link" role="button" @click.native="closeMenuMobile">
                            <i class="ni ni-collection d-lg-none"></i>
                            <span class="nav-link-inner--text">Новости</span>
                        </router-link>
                    </li>
                    <li tag="li" class="nav-item usually">
                        <router-link slot="title" to="/contacts" class="nav-link" role="button" @click.native="closeMenuMobile">
                            <i class="ni ni-collection d-lg-none"></i>
                            <span class="nav-link-inner--text">Контакты</span>
                        </router-link>
                    </li>
                    <base-dropdown class="nav-item">
                        <a slot="title" class="nav-link" data-toggle="dropdown" role="button">
                            <i class="ni ni-ui-04 d-lg-none"></i>
                            <span class="nav-link-inner--text">Ещё</span>
                        </a>
                        <router-link to="/reviews" class="dropdown-item" @click.native="closeMenuMobile">Отзывы</router-link>
                        <router-link to="/konsaltingovye-uslugi" class="dropdown-item" @click.native="closeMenuMobile">Консалтинг</router-link>
                        <router-link to="/frequently-asked-questions" class="dropdown-item" @click.native="closeMenuMobile">Вопрос-ответ</router-link>
                    </base-dropdown>
                </ul>
            </div>
        </base-nav>
    </header>
</template>
<script>
    import BaseNav from "@/components/BaseNav";
    import BaseDropdown from "@/components/BaseDropdown";
    import CloseButton from "@/components/CloseButton";

    export default {
        components: {
            BaseNav,
            CloseButton,
            BaseDropdown
        },
        data() {
            return {

            }
        },
        methods:{
            closeMenuMobile(){
                document.getElementById('closeMenu').click();
            }
        }
    };
</script>
<style>
    .btn{
        font-size: 0.7rem !important;
    }
    .btn-sm{
        font-family:"Montserrat-Bold";
        font-size: 0.6rem !important;
    }
    @media (min-width: 992px) {
        .navbar {
            padding-bottom: 7px !important;
        }
        .social .nav-item a {
            padding: 0 !important;
            text-align: center;
            padding-top: 10% !important;
            width:30px;
            height:30px;
            border: 0.0625rem solid #e9ecef !important; /*#e9ecef 646c9a*/
        }
        .navbar-brand img{
            height: 100px;
        }
        .usually:hover{
            border-bottom: 5px solid var(--default);
            margin-bottom: -5px;
        }
    }
    .navbar-transparent{
        position: relative !important;
    }
    .navbar-transparent .navbar-nav .nav-link,
    .navbar-main{
        color: var(--gray-title) !important;
    }
    .collapse.navbar-collapse{
        flex-wrap: wrap;
    }
    
</style>
